var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-brand-box"},[_c('div',{staticClass:"mobile-content"},[_vm._m(0),_c('div',{staticClass:"mobile-bottom",domProps:{"innerHTML":_vm._s(_vm.cleanHtmlText(_vm.data.content))}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-top"},[_c('div',{staticClass:"mobile-en-title"},[_vm._v("BRAND")]),_c('div',{staticClass:"mobile-cn-title"},[_vm._v("品牌设计")])])
}]

export { render, staticRenderFns }